import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import AvailabilityIndicator, { getStatusMessage } from './AvailabilityIndicator';
import { getAwayMode } from '../operators/getters';
import UIIcon from 'UIComponents/icon/UIIcon';
import { EERIE } from 'HubStyleTokens/colors';
import UILink from 'UIComponents/link/UILink';
import UIFlex from 'UIComponents/layout/UIFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AgentStatusDropdown = ({
  agentStatus,
  atCapacity
}) => {
  const isAwayMode = Boolean(getAwayMode(agentStatus));
  return (
    /*#__PURE__*/
    // TODO: Make this a UISelect component for dropdown
    _jsx(UIFlex, {
      align: "center",
      children: /*#__PURE__*/_jsx(UITooltip, {
        placement: "top",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "routing-ui.agent-status.nonSeatedTooltip"
        }),
        use: "longform",
        children: /*#__PURE__*/_jsx("span", {
          className: "flex-row width-100 align-center justify-between p-x-4",
          children: /*#__PURE__*/_jsxs("span", {
            className: "display-inline-flex align-center",
            children: [/*#__PURE__*/_jsx(AvailabilityIndicator, {
              isAwayMode: isAwayMode,
              atCapacity: atCapacity
            }), /*#__PURE__*/_jsx(UILink, {
              disabled: true,
              "data-test-id": "agent-status-dropdown",
              children: getStatusMessage(isAwayMode)
            }), /*#__PURE__*/_jsx(UIIcon, {
              className: "m-left-2",
              name: "downCarat",
              color: EERIE
            })]
          })
        })
      })
    })
  );
};
AgentStatusDropdown.displayName = 'AgentStatusDropdown';
export default AgentStatusDropdown;